import { defineStore } from "pinia";
import { dashboardService } from "@/services";
import type { ICollectionStatus } from "@/types/response";
import type { ChartData } from "chart.js";

export type TBarChartData = ChartData<"bar", any, any>;

interface State {
  propertyRentCollectionChart: TBarChartData;
  storeRentCollectionChart: TBarChartData;
  propertySubscriptionCollectionChart: TBarChartData;
  currencyRate: string;
}

export const useDashboardStore = defineStore("dashboards", {
  state: () => ({}) as State,
  getters: {},
  actions: {
    async getCollectionStatus(year: number) {
      const data = await dashboardService.getCollectionStatus(year);
      this.currencyRate = data!.currencyRate;
      this.propertyRentCollectionChart = this.generateBarChart(
        data!.propertyRentCollection
      );
      this.propertySubscriptionCollectionChart = this.generateBarChart(
        data!.propertySubscriptionCollection
      );
      this.storeRentCollectionChart = this.generateBarChart(
        data!.storeRentCollection
      );
    },

    generateBarChart(collectionStatus: ICollectionStatus): TBarChartData {
      return {
        labels: collectionStatus.months,
        datasets: [
          {
            label: "Ödenen",
            data: collectionStatus.payedAmounts,
            backgroundColor: "rgba(37, 192, 37, 0.4)",
            borderColor: "rgb(37, 192, 37)",
            borderWidth: 1,
          },
          {
            label: "Kalan",
            data: collectionStatus.remainAmounts,
            backgroundColor: "rgba(255, 22, 72, 0.4)",
            borderColor: "rgb(255, 22, 72)",
            borderWidth: 1,
          },
          {
            label: "Kalan (ayrılan kiracı)",
            data: collectionStatus.formerTenantRemainAmounts ?? [],
            backgroundColor: "rgba(255, 145, 0, 0.35)",
            borderColor: "rgb(255, 145, 0)",
            borderWidth: 1,
          },
        ],
      };
    },
  },
});
